// extracted by mini-css-extract-plugin
export var productInformation = "style-module--productInformation--9201f";